import styled from "styled-components";
import { JackpotThemeType } from "../../../../../../services/jackpots/jackpots.service.interface";
import {JACKPOT_WIDGET_LAYOUT} from "../../../../jackpot-widget.component";

interface IJackpotWidgetCollectingAmountBox{
    layout: JACKPOT_WIDGET_LAYOUT;
    widgetWidth: number;
    themeType: JackpotThemeType;
}

const handleCollectingAmountFontSize = (layout: JACKPOT_WIDGET_LAYOUT, widgetWidth: number) => {
    switch (layout) {
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE:
            /** In landscape view at a widget width of 468px, the amount should be of font-size 25px */
            return widgetWidth * 25 / 468 + "px";
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE:
            /** In minimized view at a widget width of 375px, the amount should be of font-size 12px */
            return widgetWidth * 12 / 375 + "px";
        case JACKPOT_WIDGET_LAYOUT.PORTRAIT:
        default:
            /** In portrait view at a widget width of 131px, the amount should be of font-size 12px */
            return widgetWidth * 12 / 131 + "px";
    }
};

export const JackpotWidgetCollectingAmountDefaultBox = styled.div<IJackpotWidgetCollectingAmountBox>`
    ${({theme}) => theme.font.presets.bold};
    color: ${({theme}) => theme.colors.brandSecondary};

    width: ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE ? "38%" : "100%" };
    text-align: ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE ? "right" : "center" };
    font-size: ${({widgetWidth, layout}) => handleCollectingAmountFontSize(layout, widgetWidth)};
`;
